export default __webpack_public_path__ + "static/media/photo-14.fb9bdf6f.jpeg";